import { render, staticRenderFns } from "./UsersEmpty.vue?vue&type=template&id=385d9803&scoped=true&"
import script from "./UsersEmpty.vue?vue&type=script&lang=ts&"
export * from "./UsersEmpty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385d9803",
  null
  
)

export default component.exports